export const APPLICATION_ID = {
  PATTERN: /P-+[a-zA-Z0-9]/,
  MAX_LENGTH: 30,
} as const;

export const EMPTY_VALUE = '-' as const;

export const EMAIL = {
  PATTERN: /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/,
  // /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/, // RFC 5322 standard email validation
  MAX_LENGTH: 65,
} as const;

export const NRIC = {
  MAX_LENGTH: 15,
  MIN_LENGTH: 4,
} as const;

export const SQRT_SQM = {
  MIN: 500,
  MAX: 100000,
};

export const COMMON_VALIDATION = {
  MAX_LENGTH: 200,
} as const;

export const SINGAPORE_ZONE = 'Asia/Singapore' as const;

/**
 * Date FNS format
 *
 * https://date-fns.org/v3.6.0/docs/format
 */
export const DATEPICKER = {
  // DISPLAY: "yyyy-MM-dd'T'HH:mm:ss.SSSXXX",
  DISPLAY: 'dd-MMM-yyyy',
  PATTERN: 'yyyy-MM-dd',
};

/**
 * Company Name validation
 *
 * {@link https://partnersupport.singpass.gov.sg/hc/en-sg/articles/38372651663897-What-are-the-special-characters-allowed-in-Entity-Name-data-item specified by SingPass}
 */

// COMPANY_NAME
export const ENTITY_NAME = {
  PATTERN: new RegExp("[a-zA-Z0-9\\s@/&%.\\-()'ʼ‘’,;[\\]~!^_*#$+|{}<>?\\\\:=]"),
  MAX_LENGTH: COMMON_VALIDATION.MAX_LENGTH,
} as const;

// CONTACT_NAME
export const INDIVIDUAL_NAME = {
  PATTERN: new RegExp("[a-zA-Z0-9.\\-‐–—()'\\s%~,\\/\\\\@_]"),
  MAX_LENGTH: COMMON_VALIDATION.MAX_LENGTH,
} as const;

export const AREA_CODE = {
  DEFAULT: '65',
} as const;

export const PHONE_NUMBER = {
  MAX_LENGTH: 15,
} as const;

export const PDF_MIME_TYPE = '.pdf' as const;

export const BANK_STATEMENT = {
  MAX_FILE: 40,
  MAX_SIZE: 20 * 1024 * 1024, // 20 MB
  MIN_SIZE: 10, // 10 bytes
  MIME_TYPE: [
    PDF_MIME_TYPE,
    '.png',
    '.jpg',
    '.jpeg',
    '.tiff',
    '.doc',
    '.docx',
    '.xls',
    '.xlsx',
    '.xlsm',
    '.zip',
    '.7z',
    '.rar',
    '.msg',
    '.eml',
  ],
} as const;

export const E_SIGNATURE = {
  MAX_SIZE: 5 * 1024 * 1024, // 5 MB
  MIN_SIZE: 10, // 10 bytes
  MIME_TYPE: ['.png', '.jpg', '.jpeg'],
} as const;

export const VALIDATION = {
  BANK_STATEMENT,
  ENTITY_NAME,
  INDIVIDUAL_NAME,
  DATEPICKER,
  EMAIL,
  NRIC,
  SQRT_SQM,
} as const;
